let auth = null;

if( localStorage.getItem( 'token' ) ) {
    auth = `JWT ${localStorage.getItem( 'token' )}`;
}

export const reqHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': auth,
};


export const getPersonId = ()  => localStorage.getItem("person_id");

export const getParameterByName = (name, url) => {
    // const formUrl = this.props.location.search;
    //
    // if (!url) url = formUrl;
        name = name.replace(/[\[\]]/g, "\\$&");

    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


// WEBPACK FOOTER //
// src/client/helpers/authenticationHelpers.js